import Vue from 'vue'
import Vuex from 'vuex'
import router from './routes/router'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  // L'Utilisateur est il connecté à l'application ?
  isAuthenticated: false,
  // Code statut de l'authentification (code http)
  authStatus: null,
  // Position des barres de navigation (template)
  //   navBarMobile: false,
  //   navBarDesktop: false,
  user: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  authSuccess: (state) => {
    state.isAuthenticated = true
    state.authStatus = 200
  },
  authError: (state, errorCode) => {
    state.isAuthenticated = false
    state.authStatus = errorCode
  },
  authReset: (state) => {
    state.isAuthenticated = false
    state.authStatus = null
  },
  setUser(state, user) {
    state.user = user
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {}

// getters are functions
const getters = {
  /**
   * Retourne l'utilisateur courant
   * @returns {state.user|{name}}
   */
  user: state => {
    if (state.user === null) {
      if(localStorage.getItem('user')){
          state.user = JSON.parse(localStorage.getItem('user'))
      }
      else{
      console.error('Utilisateur non trouvé dans le store > redirect to login')
      router.push({
        path: '/login'
      })
      }
    }
    return state.user
  }
};

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: false
})
